import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { TagList } from "../../api/schemas/tags";

export const Model = S.Struct({
	page: S.Literal("Tags"),
	tags: apiData(TagList).schema,
});
export type Model = typeof Model.Type;
